<template>
        <div class="row custom-options-checkable gx-3 gy-2 p-1 match-height">
            <div class="col-lg-4 col-md-12 ml-auto">
                <label class="custom-option-item text-center p-1 bg-transparent border-primary h-100" for="credit-monitoring-agency">
                    <img
                        :src="reportStore.creditMonitoringAgencies[userStore.user.defaultCreditMonitoringAgency].icon"
                        :alt="reportStore.creditMonitoringAgencies[userStore.user.defaultCreditMonitoringAgency].name"
                    />
                    <a
                        v-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.smartcredit"
                        :href="userStore.user.affiliate_links.smart_credit"
                        target="_blank"
                        class="btn btn-sm btn-primary"
                        style="width: inherit;"
                    >
                        <span class="mr-25">Sign-Up SmartCredit</span>
                        <vue-feather type="external-link" size="12" />
                    </a>
                    <a
                        v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.myfreescorenow"
                        :href="userStore.user.affiliate_links.myfreescorenow"
                        target="_blank"
                        class="btn btn-sm btn-primary"
                        style="width: inherit;"
                    >
                        <span class="mr-25">
                            {{ localizationStore.translate('myfreescorenow.signup.title') }}
                        </span>
                        <vue-feather size="12" type="external-link" />
                    </a>
                    <a
                        v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.identityiq"
                        :href="userStore.user.affiliate_links.identity_iq"
                        target="_blank"
                        class="btn btn-sm btn-primary"
                        style="width: inherit;"
                    >
                        <span class="mr-25">
                            Sign-Up IdentityIQ
                        </span>
                        <vue-feather size="12" type="external-link" />
                    </a>
                    <a
                        v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.myscoreiq"
                        :href="userStore.user.affiliate_links.myscore_iq"
                        target="_blank"
                        class="btn btn-sm btn-primary"
                        style="width: inherit;"
                    >
                        <span class="mr-25">
                            {{ localizationStore.translate('myscoreiq.signup') }}
                        </span>
                        <vue-feather type="external-link" size="12" />
                    </a>
                    <!-- <a
                        v-else-if="userStore.user.affiliate_links && userStore.user.defaultCreditMonitoringAgency == reportStore.creditfixrrreports"
                        :href="userStore.user.affiliate_links.creditfixrrreports"
                        target="_blank"
                        class="btn btn-sm btn-primary"
                        style="width: inherit;"
                    >
                        <span class="mr-25">
                            {{ localizationStore.translate('creditfixrrreports.signup') }}
                        </span>
                        <vue-feather type="external-link" size="12" />
                    </a> -->
                    <p class="text-primary">
                        Selected
                    </p>
                </label>
            </div>
            <div class="col-lg-4 col-md-12 mr-auto">
                <label @click="openModal('#credit-monitoring-agencies-modal')" class="custom-option-item text-center p-1 bg-transparent h-100">
                    <vue-feather type="more-horizontal" size="24" />
                    <h3 class="custom-option-item-title fw-bolder">Choose A Different</h3>
                    <p>Credit Monitoring Service</p>
                </label>
            </div>
        </div>
        <smart-credit-report v-if="userStore.user.defaultCreditMonitoringAgency == reportStore.smartcredit" />
        <my-free-score-now-form v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.myfreescorenow" />
        <identity-iq v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.identityiq" />
        <my-score-iq-report v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.myscoreiq" />
        <creditfixrr-reports-form v-else-if="userStore.user.defaultCreditMonitoringAgency == reportStore.creditfixrrreports" />

    <credit-monitoring-agencies-modal id="credit-monitoring-agencies-modal" />
</template>
<script>
    import { ref } from 'vue'
    import { useLocalizationStore } from '../stores/LocalizationStore.js'
    import { useReportStore } from '../stores/ReportStore.js'
    import { useUserStore } from '../stores/UserStore.js'
    import CreditMonitoringAgenciesModal from './modals/CreditMonitoringAgencies.vue';
    import CreditfixrrReportsForm from './report/form/CreditfixrrReportsComponent.vue';
    import { openModal } from '../utilities/_helpers'
    export default {
        components:{
            CreditMonitoringAgenciesModal,
            CreditfixrrReportsForm,
        },
        mounted() {
        },
        props: {
        },
        setup() {
            return {
                localizationStore: useLocalizationStore(),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                openModal: openModal,
            }
        },
        methods:{
        }
    }
</script>
